import { Suspense } from 'react';
import { NavMarker } from 'react-rhumb';
import DataSyncModalContainer from 'setup-guide-components/components/modal/dataSync/DataSyncTaskModalContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const DataSyncTaskModal = ({
  onClose,
  onOpenModal
}) => {
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: null,
    children: /*#__PURE__*/_jsx(NavMarker, {
      name: "DATA_SYNC_MODAL_SHOWN",
      children: /*#__PURE__*/_jsx(DataSyncModalContainer, {
        onClose: onClose,
        onOpenModal: onOpenModal
      })
    })
  });
};
export default DataSyncTaskModal;